<div class="progress-track" [ngStyle]="{ height: height }">
  <div class="progress-indicator"></div>
</div>
